(() => {
  'use strict';
  const tr=(key,values={})=>String(window.Q21Messages?.[key] ?? '').replace(/&amp;/g,'&').replace(/&quot;/g,'"').replace(/&#39;|&apos;/g,"'").replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/__q21_(\d+)__/g,(_,k)=>String(values['p'+k]??''));
  window.Q21StoreFaq?.destroy();
  const instances = new Map();
  const normalize = value => String(value).toLocaleLowerCase('de-DE').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/[ä]/g, 'a').replace(/[ö]/g, 'o').replace(/[ü]/g, 'u');
  function mount(root) {
    if (instances.has(root)) return;
    const search = root.querySelector('[data-faq-search]');
    const controls = root.querySelector('[data-faq-controls]');
    const counter = root.querySelector('[data-faq-count]');
    const empty = root.querySelector('[data-faq-empty]');
    const reset = root.querySelector('[data-faq-reset]');
    const clear = root.querySelector('[data-faq-clear]');
    const buttons = [...root.querySelectorAll('[data-faq-filter]')];
    const groups = [...root.querySelectorAll('[data-faq-group]')].map(node => ({ node, key: node.dataset.faqGroup, entries: [...node.querySelectorAll('details')].map(details => ({ details, text: normalize(details.textContent), wasOpen: details.open })) }));
    if (!search || !controls || !counter || !empty || !reset || !clear || !groups.length) return;
    let category = 'all';
    let wasSearching = false;
    const total = groups.reduce((sum, group) => sum + group.entries.length, 0);
    function update() {
      const terms = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
      const searching = terms.length > 0;
      let count = 0;
      for (const group of groups) {
        let matches = 0;
        for (const entry of group.entries) {
          if (searching && !wasSearching) entry.wasOpen = entry.details.open;
          const visible = (category === 'all' || group.key === category) && terms.every(term => entry.text.includes(term));
          entry.details.hidden = !visible;
          if (searching) entry.details.open = visible;
          else if (wasSearching) entry.details.open = entry.wasOpen;
          if (visible) matches++;
        }
        group.node.hidden = matches === 0;
        count += matches;
      }
      for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.faqFilter === category));
      counter.textContent = document.documentElement.lang.startsWith('en') ? `${count} of ${total} questions` : count === total && !searching && category === 'all' ? tr("text_uczxlr",{p0:total}) : `${count} ${count === 1 ? tr("text_10jc077") : tr("text_1f9vjbr")} von ${total}.`;
      empty.hidden = count !== 0;
      reset.hidden = !searching && category === 'all';
      wasSearching = searching;
    }
    function resetAll() { search.value = ''; category = 'all'; update(); search.focus(); }
    const handlers = buttons.map(button => { const handler = () => { category = button.dataset.faqFilter; update(); }; button.addEventListener('click', handler); return [button, handler]; });
    const escape = event => { if (event.key === 'Escape') resetAll(); };
    search.addEventListener('input', update);
    search.addEventListener('keydown', escape);
    reset.addEventListener('click', resetAll);
    clear.addEventListener('click', resetAll);
    controls.hidden = false;
    update();
    instances.set(root, () => {
      search.removeEventListener('input', update);
      search.removeEventListener('keydown', escape);
      reset.removeEventListener('click', resetAll);
      clear.removeEventListener('click', resetAll);
      handlers.forEach(([button, handler]) => button.removeEventListener('click', handler));
      controls.hidden = true;
      empty.hidden = true;
      groups.forEach(group => { group.node.hidden = false; group.entries.forEach(entry => { entry.details.hidden = false; if (wasSearching) entry.details.open = entry.wasOpen; }); });
    });
  }
  const mountAll = () => document.querySelectorAll('[data-q21-faq]').forEach(mount);
  const unload = event => { for (const [root, dispose] of instances) if (event.target.contains(root)) { dispose(); instances.delete(root); } };
  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:section:unload', unload);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
  window.Q21StoreFaq = { destroy() { document.removeEventListener('DOMContentLoaded', mountAll); document.removeEventListener('shopify:section:load', mountAll); document.removeEventListener('shopify:section:unload', unload); instances.forEach(dispose => dispose()); instances.clear(); } };
})();
